import { render } from "./WorkflowSettingsRequirementType.vue?vue&type=template&id=3b0270ec&scoped=true"
import script from "./WorkflowSettingsRequirementType.vue?vue&type=script&lang=js"
export * from "./WorkflowSettingsRequirementType.vue?vue&type=script&lang=js"

import "./WorkflowSettingsRequirementType.vue?vue&type=style&index=0&id=3b0270ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b0270ec"]])

export default __exports__